import {
  initialsFromEmail,
  initialsFromLabel,
  participantAccentColor,
  participantAccentEmail,
  type WaveParticipantRecord,
} from "@vida/wave-core";
import { WaveAgentAvatar } from "./WaveAgentAvatar";

type Props = {
  authorSub: string;
  authorName?: string | null;
  agentIcon?: string | null;
  agentIconS3Key?: string | null;
  participants?: WaveParticipantRecord[];
  size?: number;
  className?: string;
};

export function WaveAuthorAvatar({
  authorSub,
  authorName,
  agentIcon,
  agentIconS3Key,
  participants = [],
  size = 28,
  className = "",
}: Props) {
  const isAgent = authorSub.startsWith("agent:");
  if (isAgent) {
    return (
      <WaveAgentAvatar
        name={authorName?.trim() || authorSub}
        emoji={agentIcon}
        iconS3Key={agentIconS3Key}
        size={size}
        className={`wave-author-avatar wave-author-avatar--agent${className ? ` ${className}` : ""}`}
      />
    );
  }

  const email = participantAccentEmail(authorSub, participants, {
    label: authorName,
  });
  const initials = email
    ? initialsFromEmail(email)
    : initialsFromLabel(authorName?.trim() || authorSub, null);
  const color = participantAccentColor(authorSub, participants, {
    label: authorName,
  }).hex;

  return (
    <span
      className={`wave-author-avatar${className ? ` ${className}` : ""}`}
      style={{ width: size, height: size, backgroundColor: color, fontSize: size * 0.36 }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
